import type { AuthUser } from '@/types/auth';
import { isSystemAdmin } from '@/constants/capabilities';

export const ROUTES = {
  login: '/login',
  admin: {
    root: '/admin',
    dashboard: '/admin/dashboard',
    departments: '/admin/departments',
    users: '/admin/users',
    tasks: '/admin/tasks',
    reports: '/admin/reports',
    projects: '/admin/projects',
    projectCreate: '/admin/projects/create',
    projectDetail: (id: string) => `/admin/projects/${id}`,
    projectReports: '/admin/project-reports',
  },
  /** @deprecated 重定向至 /m */
  work: {
    root: '/work',
    reportSubmit: '/work/report',
    reportHistory: '/work/history',
    teamReports: '/work/team',
  },
  leader: {
    root: '/leader',
    reportSubmit: '/leader/report',
    reportHistory: '/leader/history',
    teamReports: '/leader/reports',
    leadershipReports: '/leader/leadership-reports',
  },
  employee: {
    root: '/employee',
    home: '/employee/home',
    reportSubmit: '/employee/report',
    reportHistory: '/employee/history',
  },
} as const;

export function getHomePath(user: AuthUser): string {
  if (isSystemAdmin(user)) {
    return ROUTES.admin.dashboard;
  }

  return ROUTES.login;
}
